import { useEffect, useState } from 'react';
import MuiDialog from '../../../../UI/MuiDialog/MuiDialog';
import Inputs from './components/inputs';
import { useTranslation } from 'react-i18next';
import useHttp from '../../../../../hooks/use-http';

import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../../../shared/api/handleErrorMessage';
import { convertBase64ToFile } from '../../../../../../utils/convertBase64ToFile';
import { isFormValid } from './isFormValid';

const INITIAL_VALUES = {
  id: 0,
  sifra: '',
  naziv: '',
  idTipaMasine: 0,
  tipMasine: '',
  kupac: '',
  idKupca: 0,
  idLokacije: 0,
  lokacija: '',
  serijskiBroj: '',
  datumKupovine: '',
  trajanjeGarancije: '',
  idStatusaMasine: 0,
  status: '',
  idKontaktOsoba: 0,
  kontaktOsoba: '',
  files: [],
  listaKlijentMasina: [],
  listaKlijentAlat: [],
  listaKlijentProizvod: [],
  listaKarakteristika: [],
  listaKonstruktora: [],
  dodatneInformacije: '',
};

const MasineForm = ({
  openDialog,
  setOpenDialog,
  machineId,
  vratiMasine,
  idKlijenta,
}) => {
  const { getData } = useHttp('');
  const { t, i18n } = useTranslation();
  const [formValue, setFormValue] = useState(INITIAL_VALUES);
  const [b64Slika, setB64Slika] = useState('');

  const vratiSlikuB64 = async () => {
    const config = {
      method: 'POST',
      url: 'Masine/konvertovanje_base64_sa_id_masine',
      data: { id: machineId },
    };
    const response = await getData(config);

    if (!response.includes('Nema')) {
      setB64Slika(response);
    }
  };

  const vratiMasinuZaId = async () => {
    const config = {
      method: 'POST',
      url: 'Masine/vrati_masinu_za_id',
      data: { id: machineId, metadata: i18n.language },
    };

    const response = await getData(config);

    if (response?.id === machineId) {
      console.log('masina', response);
      setFormValue({ ...response, files: [] });
    }
  };
  useEffect(() => {
    if (machineId === 0 || machineId === null || machineId === undefined) {
      setFormValue(INITIAL_VALUES);
    } else {
      vratiMasinuZaId();
      vratiSlikuB64();
    }
  }, [machineId, i18n.language]);

  useEffect(() => {
    if (formValue.name !== null && formValue.type !== null && b64Slika !== '') {
      const resultSlika = convertBase64ToFile(
        b64Slika,
        formValue.name,
        formValue.type,
      );

      setFormValue((curr) => {
        return { ...curr, files: [resultSlika] };
      });
    }
  }, [formValue.name, formValue.type, b64Slika]);

  const handleSave = async () => {
    console.log('cuvanje masine', formValue.files[0]);
    if (isFormValid(formValue, t)) {
      return;
    }
    const fd = new FormData();
    fd.append('id', formValue.id);
    fd.append('sifra', formValue.sifra);
    fd.append('IdKorProm', +localStorage.getItem('idKorisnika'));
    // fd.append('naziv', formValue.naziv);
    fd.append('idTipaMasine', formValue.idTipaMasine);
    fd.append('idLokacije', formValue.idLokacije);
    fd.append('serijskiBroj', formValue.serijskiBroj);
    fd.append(
      'datumKupovine',
      formValue.datumKupovine === null ? '' : formValue.datumKupovine,
    );
    fd.append('trajanjeGarancije', +formValue.trajanjeGarancije);
    fd.append('idStatusaMasine', +formValue.idStatusaMasine);
    fd.append('idKontaktOsoba', +formValue.idKontaktOsoba);
    fd.append('idKupca', +formValue.idKupca);
    if (formValue.listaKlijentMasina?.length > 0) {
      fd.append('Masine', JSON.stringify(formValue.listaKlijentMasina));
    } else {
      fd.append('Masine', '');
    }
    if (formValue.listaKlijentAlat?.length > 0) {
      fd.append('Alati', JSON.stringify(formValue.listaKlijentAlat));
    } else {
      fd.append('Alati', '');
    }
    if (formValue.listaKarakteristika?.length > 0) {
      fd.append(
        'Karakteristike',
        JSON.stringify(formValue.listaKarakteristika),
      );
    } else {
      fd.append('Karakteristike', '');
    }
    if (formValue.listaKonstruktora?.length > 0) {
      fd.append('Konstruktori', JSON.stringify(formValue.listaKonstruktora));
    } else {
      fd.append('Konstruktori', '');
    }
    if (formValue.listaKlijentProizvod?.length > 0) {
      fd.append('Proizvodi', JSON.stringify(formValue.listaKlijentProizvod));
    } else {
      fd.append('Proizvodi', '');
    }
    // for (let i = 0; i < formValue.files.length; i += 1) {
    fd.append('Slika', formValue.files[0]);
    // }
    fd.append('dodatneInformacije', formValue.dodatneInformacije);

    const config = {
      method: 'POST',
      url: formValue.id > 0 ? 'Masine/izmena_masina' : 'Masine/unos_masine',
      data: fd,
    };
    const response = await getData(config);
    if (response.id > 0) {
      const message =
        formValue.id > 0
          ? t('machineUpdatedSuccessfully')
          : t('machineAddedSuccessfully');
      toast.success(message);
      vratiMasine();
      setOpenDialog(false);
      return;
    }
    toast.error(handleErrorMessage(response));
  };

  console.log(formValue);
  return (
    <MuiDialog
      maxWidth="sm"
      open={openDialog}
      title={t('newMachine')}
      content={
        <Inputs
          formValue={formValue}
          setFormValue={setFormValue}
          idKlijenta={idKlijenta}
        />
      }
      handleClose={() => setOpenDialog(false)}
      handleConfirm={handleSave}
      deniedText="ZATVORI"
    />
  );
};

export default MasineForm;
